<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" [routerLink]="['/super-admin']"><img
            src="assets/images/admin/backarrow.png" /> Back to Backenduser Management</a>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png"/> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap mt-4 pt-2">
    <div class="adminInnerHead">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="userDetail" *ngIf="userDetail">
                    <h2>{{userDetail.first_name}} {{userDetail.last_name}}<small>Created on {{userDetail.created_dttm |
                            date:'d MMM, y'}}</small></h2>
                    <h3>Central Railway Zone</h3>
                    <div class="userDetailSocial">
                        <a href="mailto:rajeevsrivastava@gmail.com"><b><img
                                    src="assets/images/admin/mail.png" /></b>{{userDetail.email}}</a>
                        <a href="tel:+9197465 73721"><b><img
                                    src="assets/images/admin/phone.svg" /></b>{{userDetail.phone}}</a>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <ul class="customTab">
                    <!-- <li><a href="javascript:void(0);" [routerLink]="['/view_courses']" >VIEW COURSES</a> </li>
                    <li><a href="javascript:void(0);" [routerLink]="['/assign_courses']" [queryParams]="{user_id:userID}">ASSIGN COURSES</a> </li> -->
                    <li><a href="javascript:void(0);" [routerLink]="['/user_edit']"
                            [queryParams]="{id:userID,type:'edit'}" class="active">EDIT</a> </li>
                    <!-- <li class="deactiveTab"><a href="javascript:void(0);" [routerLink]="['/user_deactive']">DEACTIVATE</a> </li> -->
                </ul>
            </div>
        </div>
    </div>
    <div class="formHeading">
        <h2>Edit</h2>
        <p>Edit the user’s details</p>
    </div>
    <form [formGroup]="userForm">
        <div class="formArea">
            <div class="col-12 col-md-6">
                <div class="commanInput">
                    <mat-form-field class="example-full-width">
                        <mat-label>First Name</mat-label>
                        <input matInput formControlName="first_name"
                            [ngClass]="{ 'is-invalid': submitted && f.first_name.errors }" autocomplete="off">
                    </mat-form-field>
                    <div *ngIf="submitted && f.first_name.errors">
                        <span *ngIf="f.first_name.errors.required" class="text-mute text-danger errorText">This field is
                            required</span>
                        <span *ngIf="f.first_name.errors.pattern" class="text-mute text-danger errorText">Only alphabets
                            are allowed</span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="commanInput">
                    <mat-form-field class="example-full-width">
                        <mat-label>Last Name</mat-label>
                        <input matInput formControlName="last_name"
                            [ngClass]="{ 'is-invalid': submitted && f.last_name.errors }" autocomplete="off">
                    </mat-form-field>
                    <div *ngIf="submitted && f.last_name.errors">
                        <!-- <span *ngIf="f.last_name.errors.required" class="text-mute text-danger errorText">This field is required</span> -->
                        <span *ngIf="f.last_name.errors.pattern" class="text-mute text-danger errorText">Only alphabets
                            are allowed</span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="commanInput">
                    <mat-form-field class="example-full-width">
                        <mat-label>Email ID</mat-label>
                        <input matInput formControlName="email"
                            [ngClass]="{ 'is-invalid': submitted && f.email.errors }" autocomplete="off">
                    </mat-form-field>
                    <div *ngIf="submitted && f.email.errors">
                        <span *ngIf="f.email.errors.required" class="text-mute text-danger errorText">This field is
                            required</span>
                        <span *ngIf="f.email.errors.pattern" class="text-mute text-danger errorText">email already
                            exists</span>
                    </div>
                    <span class="text-mute text-danger errorText"
                        *ngIf="emailError=='Email already exist.'">{{emailError}}</span>

                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="commanInput">
                    <mat-form-field class="example-full-width">
                        <mat-label>Phone Number</mat-label>
                        <input matInput formControlName="phone"
                            [ngClass]="{ 'is-invalid': submitted && f.phone.errors }" numbersOnly maxlength="10"
                            autocomplete="off">
                    </mat-form-field>
                    <div *ngIf="submitted && f.phone.errors">
                        <span *ngIf="f.phone.errors.required" class="text-mute text-danger errorText">This field is
                            required</span>
                        <span *ngIf="f.phone.errors.pattern" class="text-mute text-danger errorText">Please input valid
                            phone number</span>
                        <span *ngIf="f.phone.errors.minLength" class="text-mute text-danger errorText">Please enter
                            mininmum 10 digit</span>
                        <span *ngIf="f.phone.errors.maxLength" class="text-mute text-danger errorText">Please enter
                            maxmimum 10 digit</span>
                    </div>
                    <span class="text-mute text-danger errorText" *ngIf="phoneError =='Phone already exists.'">{{
                        phoneError}}</span>
                    <span class="text-mute text-danger errorText"
                        *ngIf="phoneError =='Please input valid phone number'">{{ phoneError}}</span>
                </div>
            </div>
            <div class="col-12 col-md-12">
                <div class="customCheck">
                    <div class="row">
                        <mat-label>ACCESS</mat-label>
                    </div><br>
                    <span class="text-mute text-danger errorText" *ngIf="accessError==1">Please give atleast one
                        access</span>
                    <div class="row">
                        <div class="col-3">
                            <mat-checkbox color="primary" formControlName="backend_user_mgmt" [ngModel]="isCheckeds"
                                [checked]="false" id="backend_user_mgmt" (change)="onChange($event)">All (Super
                                Admin)</mat-checkbox>
                        </div>
                        <div class="col-3">
                            <mat-checkbox color="primary" formControlName="user_mgmt_access" [ngModel]="isCheckeds"
                                [checked]="false" id="user_mgmt_access" (change)="onChange($event)">User
                                Management</mat-checkbox>
                        </div>
                        <div class="col-3">
                            <mat-checkbox color="primary" formControlName="assessment_access" [ngModel]="isCheckeds"  [checked]="false" id="assessment_access" value="assessment_access" (change)="onChange($event)">Manage
                                Assessments</mat-checkbox>
                        </div>
                        <div class="col-3">
                            <mat-checkbox color="primary" formControlName="course_mgmt_access" [ngModel]="isCheckeds"
                                id="course_mgmt_access" [checked]="false" (change)="onChange($event)">Course
                                Management</mat-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3">
                            <mat-checkbox color="primary" formControlName="organisation_mgmt_access"
                                [ngModel]="isCheckeds" [checked]="false" id="organisation_mgmt_access"
                                (change)="onChange($event)">Organisation Management</mat-checkbox>
                        </div>
                        <div class="col-3">
                            <mat-checkbox color="primary" formControlName="content_authoring_access"
                                [ngModel]="isCheckeds" id="content_authoring_access" [checked]="false"
                                (change)="onChange($event)">Content Authoring</mat-checkbox>
                        </div>
                        <div class="col-3">
                            <mat-checkbox color="primary" formControlName="organisation_mgmt_access"
                                [ngModel]="isCheckeds" id="reset_rqsts_access" [checked]="false"
                                (change)="onChange($event)">Reset Requests</mat-checkbox>
                        </div>
                        <div class="col-3">
                            <mat-checkbox color="primary" formControlName="ticket_access" [ngModel]="isCheckeds" id="ticket_access" [checked]="false" (change)="onChange($event)" value="ticket_access"> Manage Tickets</mat-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3">
                            <mat-checkbox color="primary" formControlName="reports_access" id="reports_access"
                                [ngModel]="isCheckeds" [checked]="false"
                                (change)="onChange($event)">Reports</mat-checkbox>
                        </div>
                        <div class="col-3">
                            <mat-checkbox color="primary" formControlName="settings_access" id="settings_access"
                                [ngModel]="isCheckeds" [checked]="false"
                                (change)="onChange($event)">Settings</mat-checkbox>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <br>
            <br>
            <br>
            <div class="d-flex w-100 align-items-center justify-content-center">
                <a href="javascript:void(0);" class="backPage ml-2 mr-2" [routerLink]="['/super-admin']">Cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm ml-2 mr-2"
                    (click)="editUser(userForm.value)">Update
                    User</a>
            </div>
        </div>
    </form>
    <!-- <a href="javascript:void(0);" (click)="open(update)" class="backPage ml-2 mr-2"> open model</a> -->
</div>

<input type="hidden" (click)="open(update)" id="successMsg">


<ng-template #update let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>User Edit</h6>
                <p class="size18">User updated sucessfully.</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">OK</a>
            </div>
        </div>
    </div>
</ng-template>